<a
  class="block border-2 text-center rounded-8 px-16 py-8 rounded transition w-full bg-red-orange border-transparent"
  [href]="registerLink"
  target="_blank"
  >
  <span class="strong text-white">Register</span>
</a>
